/* eslint-disable prettier/prettier */
import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { api } from '~/services/api'
import { ClientFilters, ClientList, ClientsQueryParams } from '~/types/client-types'
import { Page, SourcePage } from '~/types/pagination-types'
import { convertToPage } from '~/utils/functions/functions'
import { maskRemove } from '~/utils/mask-interceptor'

export const useClientsQuery = ({
  size,
  page,
  filters,
}: ClientsQueryParams): UseQueryResult<Page<ClientList>> => {
  const fetchClients = async ({
    size,
    page,
    filters,
  }: {
    size: number
    page: number
    filters: ClientFilters | null
  }): Promise<Page<ClientList>> => {
    let formatDocument: string | undefined
    if (filters?.documento) {
      formatDocument = maskRemove(filters.documento).toUpperCase()
    }
    const { data }: { data: SourcePage<ClientList> } = await api.get('/client/list', {
      params: {
        page,
        size,
        nome: filters?.nome,
        documento: formatDocument,
        premium: filters?.premium,
        origem: filters?.origem,
        cadastrou_equipe: filters?.cadastrou_equipe,
        descricao_etapa: filters?.descricao_etapa,
        status: filters?.status,
      },
    })

    return convertToPage(data)
  }

  return useQuery<Page<ClientList>>({
    queryKey: ['clients', size, page, filters],
    queryFn: () => fetchClients({ page, size, filters }),
  })
}
